import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { PropertyTagsSubscription, PropertyTagsUser } from 'lumen/models';
import dirtyRelationship, {
  type DirtyRelationshipModel,
} from 'lumen/utils/decorators/dirty-relationship';

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
interface PropertyTags extends DirtyRelationshipModel, Model {}

const CLEARABLE_FIELDS = [
  'dorm',
  'hotelClass',
  'ownership',
  'region',
  'regionalDos',
  'regionalVp',
] as const;

@dirtyRelationship()
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class PropertyTags extends Model {
  [Type] = 'property-tags' as const;

  @belongsTo('property-tags/user', { async: false, inverse: null })
  declare dorm: PropertyTagsUser | null;

  @belongsTo('property-tags/user', { async: false, inverse: null })
  declare regionalDos: PropertyTagsUser | null;

  @belongsTo('property-tags/user', { async: false, inverse: null })
  declare regionalVp: PropertyTagsUser | null;

  @belongsTo('property-tags/subscription', { async: false, inverse: null })
  declare subscription: PropertyTagsSubscription;

  @attr('string') declare hotelClass: string | null;
  @attr('boolean') declare isReadOnly: boolean;
  @attr('string') declare ownership: string | null;
  @attr('string') declare region: string | null;

  get areClearableFieldsNull(): boolean {
    return CLEARABLE_FIELDS.every((field) => this[field] === null);
  }

  get hasUnsavedChanges(): boolean {
    return Boolean(this.hasDirtyAttributes) || this.hasDirtyRelationships;
  }

  resetClearableFields(): void {
    CLEARABLE_FIELDS.forEach((field) => {
      this[field] = null;
    });
  }
}

export default PropertyTags;
